export default __webpack_public_path__ + "static/media/vip4.bda8c760.webp";